import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2bdecf23"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "user-username" }

import {computed, onMounted, ref, WritableComputedRef} from "vue";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import vuetify from "@/plugins/vuetify";
import UFOLogo from "@/assets/logo-v2-dark.png";
import {useRoute} from "vue-router";
import {Language} from "@/types/Language"
import {loginUrl} from "@/utils/LoginUrl";


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const route = useRoute();
const mobileNav = ref(false);
const loadingUser = ref(false);
const store = useStore();

function translate() {
  let locale = i18n.global.locale as WritableComputedRef<Language>
  let language: Language = locale.value === "ru" ? "en" : "ru"
  localStorage.setItem("language", language);
  locale.value = language;
  vuetify.locale.current = computed(() => language);
  let title = String(route.name) + '.title'
  if (i18n.global.te(title)) document.title = i18n.global.t(title)
}

let user = computed(() => store.getters.user)

onMounted(async () => {
  loadingUser.value = true;
  await store.dispatch('getUser');
  loadingUser.value = false;
})

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_item_group = _resolveComponent("v-item-group")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_toolbar, {
      class: "pr-3 navbar",
      color: "navbar",
      elevation: "5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          class: "nav-menu",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileNav.value = !mobileNav.value))
        }),
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "main-icon",
              src: _unref(UFOLogo),
              alt: "UFO Logo"
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_toolbar_items, { class: "nav-links" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('Nav.links'), (link) => {
              return (_openBlock(), _createBlock(_component_v_btn, {
                to: link.href ? '' : _ctx.$rt(link.path),
                href: link.href ? _ctx.$rt(link.path) : '',
                target: link.blank ? '_blank' : '_self'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "nav-icon",
                    size: "25"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$rt(link.icon)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createTextVNode(_toDisplayString(_ctx.$rt(link.name)), 1)
                ]),
                _: 2
              }, 1032, ["to", "href", "target"]))
            }), 256))
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_toolbar_items, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, { onClick: translate }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "35",
                  class: "nav-icon"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("translate")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!loadingUser.value && !_unref(user)?.username)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  href: _unref(loginUrl)()
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      class: "nav-icon"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Nav.login.icon')), 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(_ctx.$t('Nav.login.name')), 1)
                  ]),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true),
            (_unref(user)?.username)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileNav.value = false)),
                  to: "/@me"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_avatar, { class: "mr-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _unref(user).avatarURL,
                          class: "user-avatar",
                          alt: "Avatar"
                        }, null, 8, _hoisted_2)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(user).username), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (loadingUser.value)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 2,
                  disabled: "",
                  class: "login"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, { indeterminate: "" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (mobileNav.value)
      ? (_openBlock(), _createBlock(_component_v_list, {
          key: 0,
          class: "mobileNav",
          "bg-color": "mobileNav",
          color: "primary",
          elevation: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_item_group, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileNav.value = false))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('Nav.links'), (link) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    "min-height": "55",
                    "prepend-icon": _ctx.$rt(link.icon),
                    to: link.href ? '' : _ctx.$rt(link.path),
                    href: link.href ? _ctx.$rt(link.path) : '',
                    target: link.blank ? '_blank' : '_self'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$rt(link.name)), 1)
                    ]),
                    _: 2
                  }, 1032, ["prepend-icon", "to", "href", "target"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})